import { useState } from 'react';
import { apiClient, parseHttpError } from '@cyberint/common-utils';
import { useSnackbars } from '@cyberint/dsc';
import { t } from '../../../i18n';

const { fesClient } = apiClient;

export const useContactAdmin = () => {
  const { errorSnackbar, successSnackbar } = useSnackbars();
  const [isLoading, setLoading] = useState(false);
  const [isOpenContactAdmin, setOpen] = useState(false);
  const [message, setMessage] = useState(null);

  const openModal = event => {
    event?.preventDefault();
    setOpen(true);
  };

  const closeModal = event => {
    event?.preventDefault();
    setOpen(false);
    setMessage(null);
  };

  const sendMessage = async () => {
    try {
      setLoading(true);
      await fesClient.post('/notifications/notify-admin', { message });

      setLoading(false);
      successSnackbar(t('topbar.contactMyAdminSuccess'));
      closeModal();
    } catch (err) {
      setLoading(false);
      errorSnackbar(parseHttpError(err, t('topbar.contactMyAdminFail')));
    }
  };

  return { sendMessage, openModal, closeModal, isOpenContactAdmin, setMessage, isLoading, message };
};
